<template>
    <div class="grid">
        <div class="grid-title">
        <h4>{{$t('_PAYGATE.CONFIGURATION')}} {{ $t("HEADER_FOOTER_CONFIG") }}</h4>
         <v-btn color="primary" class="pl-10 pr-10" @click="saveMenu">{{ $t("SAVE") }}</v-btn>
        </div>
        <div class="grid-body p-3 border-top-unset">
            <div id="theme">
                <div class="tab-content p-0">
                    <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        color="basil"
                        grow
                        >
                        <v-tab>{{ $t("_CONFIGURATION.MENU") }}</v-tab>
                        <v-tab>{{ $t("_CONFIGURATION.WIDGET") }}</v-tab>
                        <v-tab>{{ $t("_CONFIGURATION.THEME") }}</v-tab>
                        <v-tab>{{ $t("_CONFIGURATION.SCRIPT") }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab" class="mt-4">
                        <v-tab-item>
                            <div class="pb-3">
                                <v-select class="w-30 mt-3" :items="itemsLang" v-model="languageMenu" :label="$t('MENU_EDIT')" dense outlined item-text="label" item-value="value"></v-select>
                                <v-row>
                                    <v-col>
                                        <div class="bg-F5F5F5 mb-3">
                                            <b class="fs-12 text-uppercase">{{$t('ADD_NEW_MENU')}} {{ $t("_CONFIGURATION.HEADER") }}</b>
                                            <div class="mt-3">
                                                <v-text-field id="nameH" :label="$t('MENU_NAME')" :class="requiedMenuHeader === true && (nameHeader === null || nameHeader === '') ? 'border-danger' : ''" v-model="nameHeader" dense outlined></v-text-field>
                                            </div>
                                            <div class="mt-3">
                                                <v-text-field id="urlH" :label="$t('URL')" :class="requiedMenuHeader === true && (urlHeader === null || urlHeader === '') ? 'border-danger' : ''" v-model="urlHeader" dense outlined> </v-text-field>
                                            </div>
                                            <div class="text-right"> <v-btn class="btn-save mt-3" color="primary"  @click="addNew('header')"><i class="icon-plus"></i> {{$t('ADD_NEW')}}</v-btn></div>
                                        </div>
                                        <div class="bg-F5F5F5">
                                            <p><b class="fs-12 text-uppercase">{{ $t("_CONFIGURATION.MENU_HEADER") }}</b></p>
                                            <v-row>
                                                <v-col md="12">
                                                    <div>
                                                        <draggable v-if="!loadingRemove" class="list-group-theme" v-model="dataDetail[`header`].data[`${languageMenu}`]" group="people">
                                                            <div class="item" v-for="(el, index) in dataDetail[`header`].data[`${languageMenu}`]" :key="index">
                                                                <v-expansion-panels class="mb-2">
                                                                     <v-expansion-panel>
                                                                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                                        <strong>{{ el.name }}</strong> <i class="icon-Error text-danger" v-if="el.name === null || el.name === '' || el.href === null || el.href === ''"></i>
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content> 
                                                                            <div class="mt-3">
                                                                                <v-text-field :label="$t('MENU_NAME') + '*'" :class="el.name === null || el.name === '' ? 'required-valid-menu border-danger' : ''"  v-model="el.name" dense outlined></v-text-field>
                                                                            </div>
                                                                            <div class="mt-3">
                                                                                <v-text-field :label="$t('URL')" :class="el.href === null || el.href === '' ? 'required-valid-menu border-danger' : ''"  v-model="el.href" dense outlined></v-text-field>
                                                                            </div>
                                                                            <div class="mt-3 text-right">
                                                                                <v-btn color="error" @click="remove(index, dataDetail[`header`].data[`${languageMenu}`])">{{$t('DELETE')}}</v-btn>
                                                                            </div>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                                <draggable v-if="!loadingRemove" class="list-group-theme" v-model="el.elements" group="people">
                                                                    <div class="item-sub" v-for="(element, index) in el.elements" :key="index" >
                                                                        <v-expansion-panels class="mb-2">
                                                                            <v-expansion-panel>
                                                                                <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                                                    <div>{{ element.name }} <i class="icon-Error text-danger" v-if="element.name === null || element.name === '' || element.href === null || element.href === ''"></i></div>
                                                                                </v-expansion-panel-header>
                                                                                <v-expansion-panel-content> 
                                                                                     <div class="mt-3">
                                                                                        <v-text-field :label="$t('MENU_NAME') + '*'" :class="element.name === null || element.name === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.name" dense outlined></v-text-field>
                                                                                    </div>
                                                                                    <div class="mt-3">
                                                                                        <v-text-field :label="$t('URL')" :class="element.href === null || element.href === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.href" dense outlined></v-text-field>
                                                                                    </div>
                                                                                    <div class="mt-3 text-right">
                                                                                        <v-btn color="error" @click="remove(index, el.elements)">{{$t('DELETE')}}</v-btn>
                                                                                    </div>
                                                                                </v-expansion-panel-content>
                                                                            </v-expansion-panel>
                                                                        </v-expansion-panels>
                                                                    </div>
                                                                </draggable>
                                                            </div>
                                                        </draggable>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </v-col>
                                    <v-col>
                                        <div class="bg-F5F5F5 mb-3">
                                            <b class="fs-12 text-uppercase">{{$t('ADD_NEW_MENU')}} {{ $t("_CONFIGURATION.FOOTER") }}</b>
                                            <div class="mt-3">
                                                <v-text-field id="name" :label="$t('MENU_NAME')" :class="requiedMenu === true && (name === null || name === '') ? 'border-danger' : ''" v-model="name" dense outlined></v-text-field>
                                            </div>
                                            <div class="mt-3">
                                                <v-text-field id="url" :label="$t('URL')" :class="requiedMenu === true && (url === null || url === '') ? 'border-danger' : ''" v-model="url" dense outlined></v-text-field>
                                            </div>
                                            <div class="text-right"> <v-btn class="btn-save mt-3" color="primary"  @click="addNew('footer')"><i class="icon-plus"></i> {{$t('ADD_NEW')}}</v-btn></div>
                                        </div>
                                        <div class="bg-F5F5F5">
                                            <p><b class="fs-12 text-uppercase">{{ $t("_CONFIGURATION.MENU_FOOTER") }}</b></p>
                                            <v-row>
                                                <v-col md="12">
                                                    <div>
                                                        <draggable v-if="!loadingRemove" class="list-group-theme" v-model="dataDetail[`footer`].data[`${languageMenu}`]" group="people">
                                                            <div class="item" v-for="(el, index) in dataDetail[`footer`].data[`${languageMenu}`]" :key="index">
                                                                <v-expansion-panels class="mb-2">
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                                            <strong>{{ el.name }}</strong>
                                                                            <i class="icon-Error text-danger" v-if="el.name === null || el.name === '' || el.href === null || el.href === ''"></i>
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content> 
                                                                            <div class="mt-3">
                                                                                <v-text-field :label="$t('MENU_NAME') + '*'"  :class="el.name === null || el.name === '' ? 'required-valid-menu border-danger' : ''"  v-model="el.name" dense outlined></v-text-field>
                                                                            </div>
                                                                            <div class="mt-3">
                                                                                <v-text-field :label="$t('URL')" :class="el.href === null || el.href === '' ? 'required-valid-menu border-danger' : ''"  v-model="el.href" dense outlined></v-text-field>
                                                                            </div>
                                                                            <div class="mt-3 text-right">
                                                                                <v-btn color="error" @click="remove(index, dataDetail[`footer`].data[`${languageMenu}`])">{{$t('DELETE')}}</v-btn>
                                                                            </div>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                                <draggable v-if="!loadingRemove" class="list-group-theme" v-model="el.elements" group="people">
                                                                    <div class="item-sub" v-for="(element, index) in el.elements" :key="index" >
                                                                        <v-expansion-panels class="mb-2">
                                                                            <v-expansion-panel>
                                                                                <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                                                     <div>{{ element.name }} <i class="icon-Error text-danger" v-if="element.name === null || element.name === '' || element.href === null || element.href === ''"></i></div>
                                                                                </v-expansion-panel-header>
                                                                                <v-expansion-panel-content> 
                                                                                    <div class="mt-3">
                                                                                        <v-text-field :label="$t('MENU_NAME') + '*'" :class="element.name === null || element.name === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.name" dense outlined></v-text-field>
                                                                                    </div>
                                                                                    <div class="mt-3">
                                                                                        <v-text-field :label="$t('URL')" :class="element.href === null || element.href === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.href" dense outlined></v-text-field>
                                                                                    </div>
                                                                                    <div class="mt-3 text-right">
                                                                                        <v-btn color="error" @click="remove(index, el.elements)">{{$t('DELETE')}}</v-btn>
                                                                                    </div>
                                                                                </v-expansion-panel-content>
                                                                            </v-expansion-panel>
                                                                        </v-expansion-panels>
                                                                    </div>
                                                                </draggable>
                                                            </div>
                                                        </draggable>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-tab-item>

                        <v-tab-item>
                            <v-select class="w-30 mt-3" :items="itemsLang" v-model="language" :label="$t('WIDGETS_EDIT')" dense outlined item-text="label" item-value="value"></v-select>
                            <v-row>
                                <v-col md="6" class="mb-3">
                                    <div class="bg-F5F5F5 mb-3">
                                        <b class="fs-12 text-uppercase">{{ $t("_CONFIGURATION.WIDGET_HTML_TEXT") }}</b>
                                        <div class="mt-3">
                                            <v-text-field id="widgetsName" :label="$t('TITLE')" :class="requiedAddNew === true && (widgetsName === null || widgetsName === '') ? 'border-danger' : ''" v-model="widgetsName" dense outlined></v-text-field>
                                        </div>
                                        <div class="mt-3">
                                            <v-textarea id="widgetsContent" dense outlined :label="$t('CONTENT_WIDGETS')" v-model="widgetsContent" :class="requiedAddNew === true && (widgetsContent === null || widgetsContent === '') ? 'border-danger' : ''"></v-textarea>
                                        </div>
                                        <div class="mt-3">
                                            <v-select class="mt-3" :items="options" v-model="selected_widget_html" dense outlined item-text="text" item-value="value"></v-select>
                                        </div>
                                        <div class="text-right mt-3">
                                            <v-btn class="btn-save" color="primary" @click="addNewWidgets()"><i class="icon-plus"></i> {{$t('ADD_NEW')}}</v-btn>
                                        </div>
                                    </div>
                                    <div class="bg-F5F5F5 mb-3">
                                        <b class="fs-12 text-uppercase">{{ $t("_CONFIGURATION.WIDGET_SOCIAL_MEDIA_ICON") }}</b>
                                        <div class="mt-3">
                                            <v-text-field id="widgetsName_icon" :label="$t('TITLE')" :class="requiedAddNew_icon === true && (widgetsName_icon === null || widgetsName_icon === '') ? 'border-danger' : ''" v-model="widgetsName_icon" dense outlined></v-text-field>
                                        </div>
                                        <div class="mt-3">
                                            <v-textarea id="widgetsContent_icon" dense outlined :label="$t('CONTENT_WIDGETS')" v-model="widgetsContent_icon" :class="requiedAddNew_icon === true && (widgetsContent_icon === null || widgetsContent_icon === '') ? 'border-danger' : ''"></v-textarea>
                                        </div>
                                        <div class="mt-3">
                                            <template v-if="widgetsIcon.length > 0">
                                                <div v-for="(i, index_icon) in widgetsIcon" :key="index_icon" class="mb-3">
                                                    <b-form inline class="form-icon">
                                                        <v-select :items="options_icon" v-model="i.icon" dense outlined item-text="text" item-value="value" class="mr-2 mw-200"></v-select>
                                                        <v-text-field :id="'url_icon'+index_icon" :label="$t('URL')" :class="requiedAddNew_icon === true && (i.url === null || i.url === '') ? 'border-danger required-valid-icon  mr-2' : 'mr-2'" v-model="i.url" dense outlined></v-text-field>
                                                        <v-btn color="error" class="btn-delete-icon" @click="remove(index_icon, widgetsIcon)"><i class="icon-delete-ic"></i></v-btn>
                                                    </b-form>
                                                </div>
                                            </template>
                                                <div class="mt-3">
                                                <v-btn class="btn-save-icon" depressed @click="addWidgetIcon(widgetsIcon)">{{$t('ADD_NEW_SOCIAL_NETWORK')}}</v-btn>
                                            </div>
                                        </div>
                                        <div class="mt-3">
                                            <v-select :items="options" v-model="selected_widget_icon" dense outlined item-text="text" item-value="value"></v-select>
                                        </div>
                                        <div class="text-right mt-3">
                                            <v-btn class="btn-save" color="primary" @click="addNewWidgets_icon()"><i class="icon-plus"></i> {{$t('ADD_NEW')}}</v-btn>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col md="6">
                                    <div class="bg-F5F5F5 mb-3">
                                        <p><b class="fs-12 text-uppercase">{{ $t("_CONFIGURATION.FOOTER_RIGHT") }}</b></p>
                                        <template>
                                        <draggable class="list-group-theme" v-model="widgets[`${language}`].list3" group="people">
                                            <div v-for="(element, index) in widgets[`${language}`].list3" :key="index" >
                                                <v-expansion-panels class="mb-2">
                                                    <v-expansion-panel>
                                                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                            <div>{{ element.title }} <i class="icon-Error text-danger" v-if="element.title === null || element.title === '' || element.content === null || element.content === ''"></i></div>
                                                        </v-expansion-panel-header>
                                                        <v-expansion-panel-content> 
                                                            <div class="mt-3">
                                                                <v-text-field :label="$t('TITLE')" :class="element.title === null || element.title === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.title" dense outlined></v-text-field>
                                                            </div>
                                                            <div class="mt-3">
                                                                <v-textarea dense outlined :label="$t('CONTENT_WIDGETS')" :class="element.content === null || element.content === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.content"></v-textarea>
                                                            </div>
                                                            <template v-if="element.icons && element.icons.length > 0">
                                                                <div v-for="(i, index_icon) in element.icons" :key="index_icon" class="mt-3">
                                                                    <b-form inline class="form-icon">
                                                                        <b-form-select v-model="i.icon" :options="options_icon" class="mr-2 mw-200"></b-form-select>
                                                                        <v-text-field :id="'url_icon'+index_icon" :label="$t('URL')" :class="i.url === null || i.url === '' ? 'border-danger required-valid-menu mr-2' : 'mr-2'" v-model="i.url" dense outlined></v-text-field>
                                                                        <v-btn color="error" class="btn-delete-icon" @click="remove(index_icon, element.icons)"><i class="icon-delete-ic"></i></v-btn>
                                                                    </b-form>
                                                                </div>
                                                            </template>
                                                            <div class="mt-3">
                                                                <v-btn class="btn-save-icon" depressed @click="addWidgetIcon(element.icons)">{{$t('ADD_NEW_SOCIAL_NETWORK')}}</v-btn>
                                                            </div>
                                                            <div class="mt-3 text-right">
                                                                <v-btn color="error" @click="remove(index, widgets[`${language}`].list3)">{{$t('DELETE')}}</v-btn>
                                                            </div>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>
                                            </div>
                                        </draggable>
                                        </template>
                                    </div>
                                    <div class="bg-F5F5F5 mb-3">
                                        <p><b class="fs-12 text-uppercase">{{ $t("_CONFIGURATION.FOOTER_BOTTOM") }}</b></p>
                                        <draggable  class="list-group-theme" v-model="widgets[`${language}`].list4" group="people">
                                            <div v-for="(element, index) in widgets[`${language}`].list4" :key="index" >
                                                <v-expansion-panels class="mb-2">
                                                    <v-expansion-panel>
                                                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                            <div>{{ element.title }} <i class="icon-Error text-danger" v-if="element.title === null || element.title === '' || element.content === null || element.content === ''"></i></div>
                                                        </v-expansion-panel-header>
                                                        <v-expansion-panel-content> 
                                                        <template>
                                                            <div class="mt-3">
                                                                    <v-text-field :label="$t('TITLE')" :class="element.title === null || element.title === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.title" dense outlined></v-text-field>
                                                                </div>
                                                                <div class="mt-3">
                                                                    <v-textarea dense outlined :label="$t('CONTENT_WIDGETS')" :class="element.content === null || element.content === '' ? 'required-valid-menu border-danger' : ''"  v-model="element.content"></v-textarea>
                                                                </div>
                                                        </template>
                                                            <template v-if="element.icons && element.icons.length > 0">
                                                                <div v-for="(i, index_icon) in element.icons" :key="index_icon" class="mt-3">
                                                                    <b-form inline class="form-icon">
                                                                        <b-form-select v-model="i.icon" :options="options_icon" class="mr-2 mw-200"></b-form-select>
                                                                        <v-text-field :id="'url_icon'+index_icon" :label="$t('URL')" :class="i.url === null || i.url === '' ? 'border-danger required-valid-menu mr-2' : 'mr-2'" v-model="i.url" dense outlined></v-text-field>
                                                                        <v-btn color="error" class="btn-delete-icon" @click="remove(index_icon, element.icons)"><i class="icon-delete-ic"></i></v-btn>
                                                                    </b-form>
                                                                </div>
                                                            </template>
                                                            <div class="mt-3">
                                                                <v-btn class="btn-save-icon" depressed @click="addWidgetIcon(element.icons)">{{$t('ADD_NEW_SOCIAL_NETWORK')}}</v-btn>
                                                            </div>
                                                            <div class="mt-3 text-right">
                                                                <v-btn color="error" @click="remove(index, widgets[`${language}`].list4)">{{$t('DELETE')}}</v-btn>
                                                            </div>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>
                                            </div>
                                        </draggable>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-tab-item>

                        <v-tab-item>
                            <b-form-group>
                                <v-row>
                                    <v-col md="4" v-for="(tmp, index) in Templates" :key="index">
                                        <b-form-radio v-model="dataDetail.header.template" name="them-radios" :value="tmp.id" @change="$event => changeTemplate($event, tmp)">{{$t('_CONFIGURATION.TEMPLATE')}} {{index + 1}}</b-form-radio>
                                        <div class="mt-3"><img :src="tmp.imageUrl" alt="tmp1" class="w-100"></div>
                                    </v-col>
                                </v-row>
                                <b-form-radio v-model="dataDetail.header.template" name="them-radios" value="CUSTOM">{{$t('CUSTOM')}}</b-form-radio>
                                <v-row class="template-color">
                                    <v-col md="3">
                                        <v-text-field v-model="dataDetail.header.text_color" outlined dense clearable :label="$t('PRIMARY_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.bg_color" outlined dense clearable :label="$t('PRIMARY_BACKGROUND_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.bg_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_header_color" outlined dense clearable :label="$t('HEADER_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_header_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.bg_header_color" outlined dense clearable :label="$t('HEADER_BACKGROUND_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.bg_header_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.footer.text_footer_color" outlined dense clearable :label="$t('FOOTER_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.footer.text_footer_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.footer.bg_footer_color" outlined dense clearable :label="$t('FOOTER_BACKGROUND_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.footer.bg_footer_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.footer.text_footer_bottom_color" outlined dense clearable :label="$t('BOTTOM_FOOTER_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.footer.text_footer_bottom_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.footer.bg_footer_bottom_color" outlined dense clearable :label="$t('BOTTOM_FOOTER_BACKGROUND_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.footer.bg_footer_bottom_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_button_color" outlined dense clearable :label="$t('BUTTON_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_button_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.bg_button_color" outlined dense clearable :label="$t('BUTTON_BACKGROUND_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.bg_button_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_btn_2_color" outlined dense clearable :label="$t('BUTTON_TEXT_COLOR_2')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_btn_2_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.bg_btn_2_color" outlined dense clearable :label="$t('BUTTON_BACKGROUND_COLOR_2')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.bg_btn_2_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <!--  -->
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.bg_label_night_color" outlined dense clearable :label="$t('LABEL_NIGHT_BACKGROUND_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.bg_label_night_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_label_night_color" outlined dense clearable :label="$t('LABEL_NIGHT_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_label_night_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.bg_promotion_color" outlined dense clearable :label="$t('PROMOTION_BACKGROUND_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.bg_promotion_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_promotion_color" outlined dense clearable :label="$t('PROMOTION_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_promotion_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.sub_background_3_color" outlined dense clearable :label="$t('SUB_BACKGROUND_3_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.sub_background_3_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_package_color" outlined dense clearable :label="$t('SUB_TEXT_3_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_package_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_price_color" outlined dense clearable :label="$t('PRICE_TEXT_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_price_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.text_price_2_color" outlined dense clearable :label="$t('TEXT_PRICE_2_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.text_price_2_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    
                                    <v-col md="3">
                                         <v-text-field v-model="dataDetail.header.rank_star_color" outlined dense clearable :label="$t('RANK_STAR_COLOR')" type="text" :disabled="dataDetail.header.template !== 'CUSTOM'">
                                            <template v-slot:append-outer>
                                                <b-form-input :disabled="dataDetail.header.template !== 'CUSTOM'" class="input-color" type="color" v-model="dataDetail.header.rank_star_color"></b-form-input>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </b-form-group>
                        </v-tab-item>
                        <v-tab-item >
                            <div >
                                <p class="font-weight-bold">{{ $t("_CONFIGURATION.HEADER") }}</p>
                                <div class="">
                                        <div class="w-100 mr-2">
                                            <v-textarea placeholder="<script src='http://example.com/site.js' async></script>" :label="$t('_CONFIGURATION.SCRIPT')" v-model="dataDetail.header.appendHeader.text" dense outlined clearable clear-icon="mdi-close-circle"></v-textarea>
                                        </div>
                                </div>
                                <p><i>{{ $t("_CONFIGURATION.SCRIPT_WILL_ADD_HEAD") }}</i></p>
                            </div>

                            <div >
                                <p class="font-weight-bold">{{$t('_CONFIGURATION.BODY')}}</p>
                                <div class="">
                                        <div class="w-100 mr-2">
                                            <v-textarea placeholder="<script src='http://example.com/site.js' async></script>" :label="$t('_CONFIGURATION.SCRIPT')" v-model="dataDetail.header.appendBody.text" dense outlined clearable clear-icon="mdi-close-circle"></v-textarea>
                                        </div>
                                </div>
                                <p><i>{{ $t("_CONFIGURATION.SCRIPT_WILL_ADD_BODY") }}</i></p>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
                <div class="mt-3">
                        <img src="@/assets/chu_thich.png" class="w-100">
                    <v-row class="m-0">
                        <v-col>
                            <p>1. {{ $t("_CONFIGURATION.LOGO") }}</p>
                            <p>2. {{ $t("_CONFIGURATION.HEADER") }}</p>
                            <p>3. {{ $t("_CONFIGURATION.MENU_HEADER") }}</p>
                            <p>4. {{ $t("_CONFIGURATION.BE_CONTENT") }}</p>
                        </v-col>
                        <v-col>
                            <p>5. {{ $t("_CONFIGURATION.FOOTER") }}</p>
                            <p>6. {{ $t("_CONFIGURATION.MENU_FOOTER") }}</p>
                            <p>7. {{ $t("_CONFIGURATION.WIDGET_FOOTER_RIGHT") }}</p>
                            <p>8. {{ $t("_CONFIGURATION.WIDGET_FOOTER_BOTTOM") }}</p>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { configBeService } from "@/_services/configbe.service.js";
import draggable from 'vuedraggable';
import Input from "@/components/Utils/Input.vue";
import { VueEditor } from "vue2-editor";
import store from "@/plugins/store";
export default {
    components: {
        "input-text": Input,
        draggable,
        VueEditor
    },
    data() {
        return {
            items: [
          'Programming',
          'Design',
          'Vue',
          'Vuetify',
        ],
        abc: null,
            tab: null,
            currentUser: JSON.parse(localStorage.getItem("currentUser")),
            name: null,
            url: null,
            nameHeader: null,
            urlHeader: null,
            language: 'vi',
            languageMenu: 'vi',
            widgetsContent: null,
            widgetsName: null,
            widgetsContent_icon: null,
            widgetsName_icon: null,
            widgets: {
                // vi: {
                //     list1: [],
                //     list2: [],
                //     list3: [],
                //     list4: [],
                // },
                // en: {
                //     list1: [],
                //     list2: [],
                //     list3: [],
                //     list4: [],
                // },
                // ja: {
                //     list1: [],
                //     list2: [],
                //     list3: [],
                //     list4: [],
                // },
                // zh: {
                //     list1: [],
                //     list2: [],
                //     list3: [],
                //     list4: [],
                // },
                // ko: {
                //     list1: [],
                //     list2: [],
                //     list3: [],
                //     list4: [],
                // }
            },
            dataDetail: {
                header: {
                    logo:
                        'https://static.oneinventory.com/images/logo.png',
                    text_color: '#335073',
                    bg_color: '#f8f8f8',
                    text_header_top_color: '#ffffff',
                    bg_header_top_color: '#335073',
                    text_header_color: '#ffffff',
                    bg_header_color: '#335073',
                    text_button_color: '#ffffff',
                    bg_button_color: '#335073',

                    bg_label_night_color: '#c0a46b',
                    text_label_night_color: '#ffffff',
                    text_package_color: '#262626',
                    bg_promotion_color: '#f2ede2',
                    text_promotion_color: '#d6c5a2',
                    text_price_color: '#c0a46b',
                    rank_star_color: '#c0a46b',
                    text_price_2_color: "#3a5074",
                    sub_background_3_color: '#FFFFFF',
                    bg_btn_2_color: '#389e0d',
                    text_btn_2_color: '#FFFFFF',
                    template: 0,
                    data: {
                        // vi: [],
                        // en: [],
                        // ja: [],
                        // zh: [],
                        // ko: []
                    },
                    widgets: {
                        // vi: [],
                        // en: [],
                        // ja: [],
                        // zh: [],
                        // ko: []
                    },
                    appendHeader: {
                        text: null
                    },
                    appendBody: {
                        text: null
                    },
                },
                footer: {
                    text_footer_bottom_color: '#335073',
                    bg_footer_bottom_color: '#ffffff',
                    text_footer_color: '#ffffff',
                    bg_footer_color: '#335073',
                    data: {
                        // vi: [],
                        // en: [],
                        // ja: [],
                        // zh: [],
                        // ko: []
                    },
                    widgets: {
                        // vi: [],
                        // en: [],
                        // ja: [],
                        // zh: [],
                        // ko: []
                    },
                },
            },
            requiedAddNew: false,
            requiedAddNew_icon: false,
            requiedMenu: false,
            requiedMenuHeader: false,
            hotelID: null,
            loadingRemove: false,

            selected_widget_html: 'list3',
            selected_widget_icon: 'list3',
            widgetsIcon: [],
            options_icon: [
                { value: 'icon-logo-facebook', text: 'Facebook' },
                { value: 'icon-logo-twitter', text: 'Twitter' },
                { value: 'icon-logo-youtube', text: 'Youtube' },
                { value: 'icon-logo-instagram', text: 'Instagram' },
            ],
            options: [
                { value: 'list3', text: this.$t("_CONFIGURATION.FOOTER_RIGHT") },
                { value: 'list4', text: this.$t("_CONFIGURATION.FOOTER_BOTTOM") },
            ],
            sysLang: this.$i18n.locale,
            itemsLang: [],
            codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : []
        };
    },
    watch: { },
    created() { 
        this.getTemplate();
        this.getItemsLang();
        this.codeLangs.forEach(e => {
            this.dataDetail.header.data[e] = [];
            this.dataDetail.header.widgets[e] = [];
            this.dataDetail.footer.data[e] = [];
            this.dataDetail.footer.widgets[e] = [];
            this.widgets[e] = {
                list1: [],
                list2: [],
                list3: [],
                list4: []
            }
        });
    },
    methods: {
        getItemsLang() {
            let languages = JSON.parse(localStorage.getItem('listLangs'));
            languages.forEach(item => {
                this.itemsLang.push(
                    {
                        value: item.languageCode,
                        label: item.name
                    }
                )
            });
        },
        checkScript(value) {
            var regex = /^<script.|\*<\/script>{1}$/i;
            return !value || regex.test(value); 
        },
        addWidgetIcon(arr) {
            this.loadingRemove = true;
            arr.push({
                icon: 'icon-logo-facebook',
                url: null,
            });
            // setTimeout(() => {
            this.loadingRemove = false;
            // }, 200);
            // this.$forceUpdate();
            
        },
        addNew(value) {
            this.loading = true;
            if (value === 'header') {
                if (this.nameHeader !== null && this.nameHeader !== '' && this.urlHeader !== null && this.urlHeader !== '') {
                    this.dataDetail[`${value}`].data[
                        `${this.languageMenu}`
                    ].push({
                        id: 1,
                        name: this.nameHeader,
                        href: this.urlHeader,
                        elements: [],
                    });
                    this.nameHeader = null;
                    this.urlHeader = null;
                    this.requiedMenuHeader = false;
                } else {
                    this.requiedMenuHeader = true;
                    if (this.nameHeader === '' || this.nameHeader === null) {
                        document.getElementById('nameH').focus();
                    } else {
                        document.getElementById('urlH').focus();
                    }
                }
            } else {
                if (this.name !== null && this.name !== '' && this.url !== null && this.url !== '') {
                    this.dataDetail[`${value}`].data[
                        `${this.languageMenu}`
                    ].push({
                        id: 1,
                        name: this.name,
                        href: this.url,
                        elements: [],
                    });
                    this.name = null;
                    this.url = null;
                    this.requiedMenu = false;
                } else {
                    this.requiedMenu = true;
                    if (this.name === '' || this.name === null) {
                        document.getElementById('name').focus();
                    } else {
                        document.getElementById('url').focus();
                    }
                }
            }
            setTimeout(() => {
                this.loading = false;
            }, 300);
            
        },
        addNewWidgets() {
            if (
                this.widgetsContent !== null &&
                this.widgetsContent !== '' &&
                this.widgetsName !== null &&
                this.widgetsName !== ''
            ) {
                this.widgets[`${this.language}`][this.selected_widget_html].push({
                    content: this.widgetsContent,
                    id: 1,
                    title: this.widgetsName,
                    icons: [],
                });
                this.widgetsContent = null;
                this.widgetsName = null;
                this.requiedAddNew = false;
            } else {
                this.requiedAddNew = true;
                if (this.widgetsContent === '' || this.widgetsContent === null) {
                    document.getElementById('widgetsContent').focus();
                } else {
                    document.getElementById('widgetsName').focus();
                }
            }
        },
        addNewWidgets_icon() {
            if (this.widgetsIcon.length > 0 && this.widgetsIcon.filter(e => !e.url).length > 0) {
                this.requiedAddNew_icon = true;
                for (let i = 0; i < this.widgetsIcon.length; i++) {
                     if (!this.widgetsIcon[i].url) {
                        document.getElementById('url_icon'+i).focus();
                        return;
                    }   
                }
            } else if (
                this.widgetsContent_icon !== null &&
                this.widgetsContent_icon !== '' &&
                this.widgetsName_icon !== null &&
                this.widgetsName_icon !== ''
            ) {
                this.widgets[`${this.language}`][this.selected_widget_icon].push({
                    content: this.widgetsContent_icon,
                    id: 1,
                    title: this.widgetsName_icon,
                    icons: [...this.widgetsIcon],
                });
                this.widgetsContent_icon = null;
                this.widgetsName_icon = null;
                this.widgetsIcon = [];
                this.requiedAddNew_icon = false;
            } else {
                this.requiedAddNew_icon = true;
                if (this.widgetsContent_icon === '' || this.widgetsContent_icon === null) {
                    document.getElementById('widgetsContent_icon').focus();
                } else {
                    document.getElementById('widgetsName_icon').focus();
                }
            }
        },
        async getTemplate() {
            await configBeService.getTemplate().then(
                res => {
                    if (res.responseCode === 0) {
                        this.Templates = res.data;
                    } else {
                        this.Templates = [];
                    }
                    this.callApiDetail();
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        async callApiDetail() {
            this.loading = true;
            await configBeService.detail(this.hotelID).then(
                response => {
                    if (response.responseCode === 0 && response.data.header !== null) {
                        this.dataDetail = response.data;
						if ( !this.dataDetail.header.appendBody ) {
							this.dataDetail.header.appendBody = {
								text: null
							};
						}
						if ( !this.dataDetail.header.appendHeader ) {
							this.dataDetail.header.appendHeader = {
								text: null
							};
						}
						
						this.dataDetail.header.appendBody
                        // this.widgets = Object.assign(
                        //     {},
                        //     {
                        //         vi: {
                        //             list1: [],
                        //             list2: [],
                        //             list3: [],
                        //             list4: [],
                        //         },
                        //         en: {
                        //             list1: [],
                        //             list2: [],
                        //             list3: [],
                        //             list4: [],
                        //         },
                        //         ja: {
                        //             list1: [],
                        //             list2: [],
                        //             list3: [],
                        //             list4: [],
                        //         },
                        //         zh: {
                        //             list1: [],
                        //             list2: [],
                        //             list3: [],
                        //             list4: [],
                        //         },
                        //         ko: {
                        //             list1: [],
                        //             list2: [],
                        //             list3: [],
                        //             list4: [],
                        //         }
                        //     },
                        // );
                        this.codeLangs.forEach(code => {
                            this.dataDetail.header.widgets[code].forEach(element => {
                                if (!element.icons) {
                                    element.icons = [];
                                }
                                if (element.position === 'HEADER_TOP') {
                                    this.widgets[code].list2.push(element);
                                }
                            });

                            this.dataDetail.footer.widgets[code].forEach(element => {
                                if (!element.icons) {
                                    const item = {
                                        icons: [],
                                        content: element.content,
                                        id: element.id,
                                        title: element.title,
                                    }
                                    if (element.position === 'FOOTER_RIGHT') {
                                        this.widgets[code].list3.push(item);
                                    }
                                    if (element.position === 'FOOTER_BOTTOM') {
                                        this.widgets[code].list4.push(item);
                                    }
                                } else {
                                    if (element.position === 'FOOTER_RIGHT') {
                                        this.widgets[code].list3.push(element);
                                    }
                                    if (element.position === 'FOOTER_BOTTOM') {
                                        this.widgets[code].list4.push(element);
                                    }
                                }
                                
                            });

                        });
                        // this.dataDetail.header.widgets.vi.forEach(element => {
                        //     if (!element.icons) {
                        //         element.icons = [];
                        //     }
                        //     if (element.position === 'HEADER_TOP') {
                        //         this.widgets.vi.list2.push(element);
                        //     }
                        // });
                        // this.dataDetail.header.widgets.en.forEach(element => {
                        //     if (!element.icons) {
                        //         element.icons = [];
                        //     }
                        //     if (element.position === 'HEADER_TOP') {
                        //         this.widgets.en.list2.push(element);
                        //     }
                        // });
                        // this.dataDetail.header.widgets.ja.forEach(element => {
                        //     if (!element.icons) {
                        //         element.icons = [];
                        //     }
                        //     if (element.position === 'HEADER_TOP') {
                        //         this.widgets.ja.list2.push(element);
                        //     }
                        // });
                        // this.dataDetail.header.widgets.zh.forEach(element => {
                        //     if (!element.icons) {
                        //         element.icons = [];
                        //     }
                        //     if (element.position === 'HEADER_TOP') {
                        //         this.widgets.zh.list2.push(element);
                        //     }
                        // });
                        // this.dataDetail.header.widgets.ko.forEach(element => {
                        //     if (!element.icons) {
                        //         element.icons = [];
                        //     }
                        //     if (element.position === 'HEADER_TOP') {
                        //         this.widgets.ko.list2.push(element);
                        //     }
                        // });
                        // this.dataDetail.footer.widgets.vi.forEach(element => {
                        //     if (!element.icons) {
                        //         const item = {
                        //             icons: [],
                        //             content: element.content,
                        //             id: element.id,
                        //             title: element.title,
                        //         }
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.vi.list3.push(item);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.vi.list4.push(item);
                        //         }
                        //     } else {
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.vi.list3.push(element);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.vi.list4.push(element);
                        //         }
                        //     }
                            
                        // });
                        // this.dataDetail.footer.widgets.en.forEach(element => {
                        //     if (!element.icons) {
                        //         const item = {
                        //             icons: [],
                        //             content: element.content,
                        //             id: element.id,
                        //             title: element.title,
                        //         }
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.en.list3.push(item);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.en.list4.push(item);
                        //         }
                        //     } else {
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.en.list3.push(element);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.en.list4.push(element);
                        //         }
                        //     }
                        // });
                        // this.dataDetail.footer.widgets.ja.forEach(element => {
                        //     if (!element.icons) {
                        //         const item = {
                        //             icons: [],
                        //             content: element.content,
                        //             id: element.id,
                        //             title: element.title,
                        //         }
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.ja.list3.push(item);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.ja.list4.push(item);
                        //         }
                        //     } else {
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.ja.list3.push(element);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.ja.list4.push(element);
                        //         }
                        //     }
                        // });
                        // this.dataDetail.footer.widgets.zh.forEach(element => {
                        //     if (!element.icons) {
                        //         const item = {
                        //             icons: [],
                        //             content: element.content,
                        //             id: element.id,
                        //             title: element.title,
                        //         }
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.zh.list3.push(item);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.zh.list4.push(item);
                        //         }
                        //     } else {
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.zh.list3.push(element);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.zh.list4.push(element);
                        //         }
                        //     }
                        // });
                        // this.dataDetail.footer.widgets.ko.forEach(element => {
                        //     if (!element.icons) {
                        //         const item = {
                        //             icons: [],
                        //             content: element.content,
                        //             id: element.id,
                        //             title: element.title,
                        //         }
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.ko.list3.push(item);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.ko.list4.push(item);
                        //         }
                        //     } else {
                        //         if (element.position === 'FOOTER_RIGHT') {
                        //             this.widgets.ko.list3.push(element);
                        //         }
                        //         if (element.position === 'FOOTER_BOTTOM') {
                        //             this.widgets.ko.list4.push(element);
                        //         }
                        //     }
                        // });
                    }
                    if (this.Templates.length > 0 && response.data.header === null) {
                        this.dataDetail.header.template = this.Templates[0].id;
                        this.dataDetail.header.text_color = this.Templates[0].theme.text_color;
                        this.dataDetail.header.bg_color = this.Templates[0].theme.bg_color;
                        this.dataDetail.header.text_header_top_color = this.Templates[0].theme.text_header_top_color;
                        this.dataDetail.header.bg_header_top_color = this.Templates[0].theme.bg_header_top_color;
                        this.dataDetail.header.text_header_color = this.Templates[0].theme.text_header_color;
                        this.dataDetail.header.bg_header_color = this.Templates[0].theme.bg_header_color;
                        this.dataDetail.header.text_button_color = this.Templates[0].theme.text_button_color;
                        this.dataDetail.header.bg_button_color = this.Templates[0].theme.bg_button_color;
                        this.dataDetail.footer.text_footer_bottom_color = this.Templates[0].theme.text_footer_bottom_color;
                        this.dataDetail.footer.bg_footer_bottom_color = this.Templates[0].theme.bg_footer_bottom_color;
                        this.dataDetail.footer.text_footer_color = this.Templates[0].theme.text_footer_color;
                        this.dataDetail.footer.bg_footer_color = this.Templates[0].theme.bg_footer_color;

                        this.dataDetail.header.bg_label_night_color = this.Templates[0].theme.bg_label_night_color ? this.Templates[0].theme.bg_label_night_color :'#c0a46b';
                        this.dataDetail.header.text_label_night_color = this.Templates[0].theme.text_label_night_color ? this.Templates[0].theme.text_label_night_color : '#ffffff';
                        this.dataDetail.header.text_package_color = this.Templates[0].theme.text_package_color ? this.Templates[0].theme.text_package_color : '#262626';
                        this.dataDetail.header.bg_promotion_color = this.Templates[0].theme.bg_promotion_color ? this.Templates[0].theme.bg_promotion_color : '#f2ede2';
                        this.dataDetail.header.text_promotion_color = this.Templates[0].theme.text_promotion_color ? this.Templates[0].theme.text_promotion_color : '#d6c5a2';
                        this.dataDetail.header.text_price_color = this.Templates[0].theme.text_price_color ? this.Templates[0].theme.text_price_color : '#c0a46b';
                        this.dataDetail.header.rank_star_color = this.Templates[0].theme.rank_star_color ? this.Templates[0].theme.rank_star_color : '#c0a46b';
                        this.dataDetail.header.text_price_2_color = this.Templates[0].theme.text_price_2_color ? this.Templates[0].theme.text_price_2_color : '#3a5074';
                        this.dataDetail.header.sub_background_3_color = this.Templates[0].theme.sub_background_3_color ? this.Templates[0].theme.sub_background_3_color : '#FFFFFF';
                        this.dataDetail.header.text_btn_2_color = this.Templates[0].theme.text_btn_2_color ? this.Templates[0].theme.text_btn_2_color : '#FFFFFF';
                        this.dataDetail.header.bg_btn_2_color = this.Templates[0].theme.bg_btn_2_color ? this.Templates[0].theme.bg_btn_2_color : '#389e0d';
                    } else if (this.Templates.length === 0 && response.data.header === null) {
                        this.dataDetail.header.template = 'CUSTOM';
                    } else {
                        this.dataDetail.header.template = 'CUSTOM';
                        this.dataDetail.header.text_color = !this.dataDetail.header.text_color ? '#335073' : this.dataDetail.header.text_color;
                        this.dataDetail.header.bg_color = !this.dataDetail.header.bg_color ? '#f8f8f8' : this.dataDetail.header.bg_color;
                        this.dataDetail.header.text_header_top_color = !this.dataDetail.header.text_header_top_color ? '#262626' : this.dataDetail.header.text_header_top_color;
                        this.dataDetail.header.bg_header_top_color = !this.dataDetail.header.bg_header_top_color ? '#335073' : this.dataDetail.header.bg_header_top_color;
                        this.dataDetail.header.text_header_color = !this.dataDetail.header.text_header_color ? '#ffffff' : this.dataDetail.header.text_header_color;
                        this.dataDetail.header.bg_header_color = !this.dataDetail.header.bg_header_color ? '#335073' : this.dataDetail.header.bg_header_color;
                        this.dataDetail.header.text_button_color = !this.dataDetail.header.text_button_color ? '#ffffff' : this.dataDetail.header.text_button_color;
                        this.dataDetail.header.bg_button_color = !this.dataDetail.header.bg_button_color ? '#335073' : this.dataDetail.header.bg_button_color;
                        this.dataDetail.footer.text_footer_bottom_color = !this.dataDetail.footer.text_footer_bottom_color ? '#335073' : this.dataDetail.footer.text_footer_bottom_color;
                        this.dataDetail.footer.bg_footer_bottom_color = !this.dataDetail.footer.bg_footer_bottom_color ? '#ffffff' : this.dataDetail.footer.bg_footer_bottom_color;
                        this.dataDetail.footer.text_footer_color = !this.dataDetail.footer.text_footer_color ? '#335073' : this.dataDetail.footer.text_footer_color;
                        this.dataDetail.footer.bg_footer_color = !this.dataDetail.footer.bg_footer_color ? '#ffffff' : this.dataDetail.footer.bg_footer_color;

                        this.dataDetail.header.bg_label_night_color = this.dataDetail.header.bg_label_night_color ? this.dataDetail.header.bg_label_night_color :'#c0a46b';
                        this.dataDetail.header.text_label_night_color = this.dataDetail.header.text_label_night_color ? this.dataDetail.header.text_label_night_color : '#ffffff';
                        this.dataDetail.header.text_package_color = this.dataDetail.header.text_package_color ? this.dataDetail.header.text_package_color : '#262626';
                        this.dataDetail.header.bg_promotion_color = this.dataDetail.header.bg_promotion_color ? this.dataDetail.header.bg_promotion_color : '#f2ede2';
                        this.dataDetail.header.text_promotion_color = this.dataDetail.header.text_promotion_color ? this.dataDetail.header.text_promotion_color : '#d6c5a2';
                        this.dataDetail.header.text_price_color = this.dataDetail.header.text_price_color ? this.dataDetail.header.text_price_color : '#c0a46b';
                        this.dataDetail.header.rank_star_color = this.dataDetail.header.rank_star_color ? this.dataDetail.header.rank_star_color : '#c0a46b';
                        this.dataDetail.header.text_price_2_color = this.dataDetail.header.text_price_2_color ? this.dataDetail.header.text_price_2_color : '#3a5074';
                        this.dataDetail.header.sub_background_3_color = this.dataDetail.header.sub_background_3_color ? this.dataDetail.header.sub_background_3_color : '#FFFFFF';
                        this.dataDetail.header.text_btn_2_color = this.dataDetail.header.text_btn_2_color ? this.dataDetail.header.text_btn_2_color : '#FFFFFF';
                        this.dataDetail.header.bg_btn_2_color = this.dataDetail.header.bg_btn_2_color ? this.dataDetail.header.bg_btn_2_color : '#389e0d';
                    }
                    this.loading = false;
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        changeTemplate(value, tmp) {
            // // console.log(value, tmp);
            this.dataDetail.header.text_color = tmp.theme.text_color;
            this.dataDetail.header.bg_color = tmp.theme.bg_color;
            this.dataDetail.header.text_header_top_color = tmp.theme.text_header_top_color;
            this.dataDetail.header.bg_header_top_color = tmp.theme.bg_header_top_color;
            this.dataDetail.header.text_header_color = tmp.theme.text_header_color;
            this.dataDetail.header.bg_header_color = tmp.theme.bg_header_color;
            this.dataDetail.header.text_button_color = tmp.theme.text_button_color;
            this.dataDetail.header.bg_button_color = tmp.theme.bg_button_color;
            this.dataDetail.footer.text_footer_bottom_color = tmp.theme.text_footer_bottom_color;
            this.dataDetail.footer.bg_footer_bottom_color = tmp.theme.bg_footer_bottom_color;
            this.dataDetail.footer.text_footer_color = tmp.theme.text_footer_color;
            this.dataDetail.footer.bg_footer_color = tmp.theme.bg_footer_color;

            this.dataDetail.header.bg_label_night_color = tmp.theme.bg_label_night_color ? tmp.theme.bg_label_night_color :'#c0a46b';
            this.dataDetail.header.text_label_night_color = tmp.theme.text_label_night_color ? tmp.theme.text_label_night_color : '#ffffff';
            this.dataDetail.header.text_package_color = tmp.theme.text_package_color ? tmp.theme.text_package_color : '#262626';
            this.dataDetail.header.bg_promotion_color = tmp.theme.bg_promotion_color ? tmp.theme.bg_promotion_color : '#f2ede2';
            this.dataDetail.header.text_promotion_color = tmp.theme.text_promotion_color ? tmp.theme.text_promotion_color : '#d6c5a2';
            this.dataDetail.header.text_price_color = tmp.theme.text_price_color ? tmp.theme.text_price_color : '#c0a46b';
            this.dataDetail.header.rank_star_color = tmp.theme.rank_star_color ? tmp.theme.rank_star_color : '#c0a46b';
            this.dataDetail.header.text_price_2_color = tmp.theme.text_price_2_color ? tmp.theme.text_price_2_color : '#3a5074';
            this.dataDetail.header.sub_background_3_color = tmp.theme.sub_background_3_color ? tmp.theme.sub_background_3_color : '#FFFFFF';

            this.dataDetail.header.text_btn_2_color = tmp.theme.text_btn_2_color ? tmp.theme.text_btn_2_color : '#FFFFFF';
            this.dataDetail.header.bg_btn_2_color = tmp.theme.bg_btn_2_color ? tmp.theme.bg_btn_2_color : '#389e0d';
        },
        remove(index, array) {
        this.loadingRemove = true;
        array.splice(index, 1);
        this.loadingRemove = false;
        },
        saveMenu() {
            this.requiedAddNew = false;
            this.requiedAddNew_icon = false;
            this.requiedMenu = false;
            const declaration = document.getElementsByClassName('required-valid-menu') || [];
            let isEmpty = false;
            for(let item in this.dataDetail) {
                for(let property in this.dataDetail[item].data) {
                    if ( this.dataDetail[item].data[property].length > 0 ) {
                            this.dataDetail[item].data[property].forEach(element => {
                                if (!element.name) {
                                    isEmpty = true;
                                    return;
                                }
                            });
                    }
                }
            }

            // if (this.dataDetail.header.script.length > 0 && this.dataDetail.header.script.find(e=> !e.value)) {
            //     isEmpty = true
            // }

            

            if (!isEmpty) {
                this.codeLangs.forEach(code => {
                        this.dataDetail.header.widgets[code] = [];
                        this.dataDetail.footer.widgets[code] = [];

                        this.widgets[code].list2.forEach(element => {
                        this.dataDetail.header.widgets[code].push({
                            content: element.content,
                            id: 1,
                            position: 'HEADER_TOP',
                            title: element.title,
                            icons: element.icons,
                        });
                    })

                        this.widgets[code].list3.forEach(element => {
                            this.dataDetail.footer.widgets[code].push({
                                content: element.content,
                                id: 1,
                                position: 'FOOTER_RIGHT',
                                title: element.title,
                                icons: element.icons,
                            });
                        });

                        this.widgets[code].list4.forEach(element => {
                            this.dataDetail.footer.widgets[code].push({
                                content: element.content,
                                id: 1,
                                position: 'FOOTER_BOTTOM',
                                title: element.title,
                                icons: element.icons,
                            });
                        });
                });
                configBeService.update(this.dataDetail).then(
                    response => {
                        if (response.responseCode === 0) {
                            store.commit("alert/display", {
                                message: this.$t('SAVE_SUCCESS'),
                                error: false,
                                success: true,
                            });
                        }
                    },
                    error => {
                        if (error.status === 403) {
                            this.showAlertLogout();
                        }
                    },
                );
            } else {
                store.commit("alert/display", {
                    message: this.$t('PLEASE_COMPLETE_THE_FIELDS_MARKED'),
                    error: true,
                    success: false,
                });
                document.getElementsByClassName('required-valid-menu')[0].focus();
            }
        },
    },
    computed: {
        draggableFooterRight() {
            return this.widgets[`${this.language}`].list3;
        },
        draggableFooterBottom() {
            return this.widgets[`${this.language}`].list4;
        },
    }
};
</script>
<style lang="scss" scoped>
    #theme{
        .template-color {
            .input-color {
                width: 35px;
                position: absolute;
                right: 15px;
                border: 0;
                top: 5px;
            }
            .form-control:focus {
                background-color: transparent;
            }
        }
        .item-sub {
            margin: 0 0 0 1.5rem;
        }
        .list-group-theme {
        }
        .bg-F5F5F5 {
            background: #F5F5F5;
            border-radius: 8px;
            padding: 18px;
        }
        .delete-btn {
            cursor: pointer;
        }
        .btn-save-icon {
            border: 2px dashed #D9D9D9;
            border-radius: 4px;
            width: 100%;
            height: 35px;
            color: #BFBFBF;
            background-color: transparent !important;
        }
        .btn:focus,
        .btn.focus {
            box-shadow: none;
        }
        .btn-delete-icon {
            // padding: 6px 10px;
            i {
                font-size: 20px;
                position: relative;
                top: 1px;
            }
        }
        .btn-save {
            color: #ffff;
            i.icon-plus {
                top: 1.5px;
                color: #000;
                background: #fff;
                border-radius: 7px;
                margin-right: 7px;
            }
        }
        .mw-200{
            max-width: 200px;
        }
    }   
</style>